import { HashFactorName } from "@utils/hash.utils";
import { ChartData, ChartOptions, Plugin } from "chart.js";

export enum ChartActions {
  SET_ALL_DATA = "setAllData",
  SET_DATA = "setData",
  SET_AXISY_NAME = "setAxisYName",
  SET_CALC_SPEED_DROPS = "setCalcSpeedDrops",
  SET_IS_SHOW_PERIOD = "setIsShowPeriod",
  SET_IS_NOT_EMPTY = "setIsNotEmpty",
  //SET_HASH_DATA = "setHashData",
  //SET_HASH_OPTIONS = "setHashOptions",
  SET_HAS_DATA = "setHasData",
  SET_H = "setH",
  SET_SELF_IS_LOADING = "setSelfIsLoading",
  SET_COORDS = "setCoords",
  SET_LAST_POINT = "setLastPoint",
  SET_COORDS_AND_LAST_POINT = "setCoordsAndLastPoint",
  SET_INFO_VISIBILITY = "setInfoVisibility",
  // SET_RANGE_PICKER_VALUE = "setRangePickerValue",
  // SET_SHOWDAY_CHOOSER = "setShowDayChooser",
  // SET_CURRENT_DAY = "setCurrentDay",
  // SET_HASH_CHART = "setHashChart",
  //
  // CLEAR_PERIOD = "clearPeriod",
  // SET_CURRENT_DAY = "setCurrentDay",
  SET_PERIOD = "setPeriod",
}

export interface IAllData {
  lastPoint: [number, number, number];
  chartData: ChartData<"line">;
  chartOptions: ChartOptions<"line">;
  plugins: Plugin<"line">[];
  hasData: boolean;
  selfIsLoading: boolean;
  axisYName: HashFactorName; //higherHashDecimal(chartData.data) as HashName
}

export interface ChartState extends IAllData {
  calcSpeedDrops: number;
  isShowPeriod: boolean;
  isNotEmpty: boolean;
  coords: [number, number];
  infoVisibility: boolean;
}

interface ChartAction {
  readonly type: ChartActions;
  readonly payload: any;
}

const chartReducer = (state: ChartState, action: ChartAction): ChartState => {
  switch (action.type) {
    case ChartActions.SET_ALL_DATA:
      const allData = action.payload as IAllData;
      return {
        ...state,
        ...allData,
      };

    case ChartActions.SET_AXISY_NAME:
      return {
        ...state,
        axisYName: action.payload,
      };

    case ChartActions.SET_CALC_SPEED_DROPS:
      return {
        ...state,
        calcSpeedDrops: action.payload,
      };

    case ChartActions.SET_IS_SHOW_PERIOD:
      return {
        ...state,
        isShowPeriod: action.payload,
      };

    case ChartActions.SET_IS_NOT_EMPTY:
      return {
        ...state,
        isNotEmpty: action.payload,
      };

    case ChartActions.SET_HAS_DATA:
      return {
        ...state,
        hasData: action.payload,
      };

    case ChartActions.SET_SELF_IS_LOADING:
      return {
        ...state,
        selfIsLoading: action.payload,
      };

    case ChartActions.SET_COORDS:
      return {
        ...state,
        coords: action.payload,
      };

    case ChartActions.SET_LAST_POINT:
      return {
        ...state,
        lastPoint: action.payload,
      };

    case ChartActions.SET_COORDS_AND_LAST_POINT:
      return {
        ...state,
        ...action.payload, // { coords, lastPoint }
      };

    case ChartActions.SET_INFO_VISIBILITY:
      return {
        ...state,
        infoVisibility: action.payload,
      };

    default:
      return { ...state };
  }
};

// export const chartInitialState: ChartState = {
//   axisYName: HashName.EH,
//   calcSpeedDrops: 0,
//   isShowPeriod: false,
//   isNotEmpty: false,
//   chartData: {
//     datasets: [],
//   },
//   chartOptions: {},
//   hasData: false,
//   selfIsLoading: true,
//   coords: [0, 0],
//   lastPoint: [0, 0],
//   infoVisibility: false,
//   period: getPeriodForToday(),
//   rangePickerValue: null,
//   currentDay: today().startOf("day"),
// }

export function createInitialState(
  calcSpeedDrops: number,
): ChartState {
  return {
    axisYName: HashFactorName.N,
    calcSpeedDrops: calcSpeedDrops,
    isShowPeriod: true, //false,
    isNotEmpty: false,
    chartData: {
      datasets: [],
    },
    chartOptions: {},
    hasData: false,
    selfIsLoading: true,
    coords: [0, 0],
    lastPoint: [0, 0, 0],
    infoVisibility: false,
    plugins: [],
    //period: ChartUtils.createPeriodForRequest(today()),
    //rangePickerValue: null,
    //currentDay: today().startOf("day"),
  }
}

export default chartReducer;
